import React, { useCallback } from 'react';
import {
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import { TimeSignalClassification } from 'graphql/types';

type NoteActionMenutItemProps = {
  classification: TimeSignalClassification;
  icon: React.ReactNode;
  title: string;
  onSave: (classification: TimeSignalClassification) => void;
  selectedClassification?: TimeSignalClassification | null;
  disabled?: boolean;
};

const useStyles = makeStyles((theme) => ({
  currentIndicatorLabel: {
    backgroundColor: theme.palette.grey[400],
    padding: theme.spacing(0, 0.25),
    borderRadius: theme.spacing(0.25)
  },
  title: {
    paddingRight: theme.spacing(3)
  },
  icon: {
    minWidth: theme.spacing(4.5)
  },
  root: {
    padding: theme.spacing(1.25, 2)
  }
}));

const NoteActionMenutItem: React.FC<NoteActionMenutItemProps> = React.forwardRef(
  (
    {
      title,
      icon,
      classification,
      selectedClassification,
      onSave,
      disabled
    }: NoteActionMenutItemProps,
    ref: React.Ref<any>
  ) => {
    const classes = useStyles();
    const onClick = useCallback(() => {
      onSave(classification);
    }, [classification, onSave]);
    return (
      <MenuItem
        key={title}
        onClick={onClick}
        data-testid={`note-action-menu-item-${classification}`}
        disabled={disabled}
        ref={ref}
        className={classes.root}
        tabIndex={0}
      >
        <ListItemIcon className={classes.icon}>{icon}</ListItemIcon>
        <ListItemText className={classes.title}>
          <FormattedMessage id={title} />
        </ListItemText>
        {selectedClassification === classification && (
          <ListItemText>
            <Typography
              variant="caption"
              className={classes.currentIndicatorLabel}
            >
              <FormattedMessage id="note.current" />
            </Typography>
          </ListItemText>
        )}
      </MenuItem>
    );
  }
);
NoteActionMenutItem.displayName = 'NoteActionMenutItem';

export default NoteActionMenutItem;
